import { useSelector, } from 'react-redux';
import { IGlobalStore, IReducerStore, } from '@Store';

export const useDevices = (): IGlobalStore['devices'] => {
  return useSelector((store: IReducerStore) => store.global.devices);
};
